import { User, UserInterface } from 'app/core/user/models';

import { CommentInterface } from './comment.model';
import { RelatedEntityInterface } from './related-entity.model';

export interface TaskInterface {
  accessLevel?: number;
  assignedTo?: UserInterface;
  comments?: CommentInterface[];
  completedBy?: UserInterface;
  completedDate?: Date;
  createdBy?: UserInterface;
  creationDate?: Date;
  dueDate?: Date;
  hours?: number;
  id?: number;
  isComplete?: boolean;
  isLastTask?: boolean;
  isOverDue?: boolean;
  isVisibleToSubject?: boolean;
  notes?: string;
  originTaskId?: number;
  relatedEntity?: RelatedEntityInterface;
  status?: string;
  subject?: UserInterface;
  summary?: string;
  taskTemplateName?: string;
  taskType?: number;
  taskTypeLabel?: string;
  updateDate?: Date;
  daysOverdue?: number;
  daysUntilDue?: number;
  daysOpen?: number;
}

export class Task implements TaskInterface {
  public accessLevel?: number;
  public assignedTo?: UserInterface;
  public comments?: CommentInterface[];
  public completedBy?: UserInterface;
  public completedDate?: Date;
  public createdBy?: UserInterface;
  public creationDate?: Date;
  public dueDate?: Date;
  public hours?: number;
  public id?: number;
  public isComplete?: boolean;
  public isLastTask?: boolean;
  public isOverDue?: boolean;
  public isVisibleToSubject?: boolean;
  public notes?: string;
  public originTaskId?: number;
  public relatedEntity?: RelatedEntityInterface;
  public status?: string;
  public subject?: UserInterface;
  public summary?: string;
  public taskTemplateName?: string;
  public taskType?: number;
  public taskTypeLabel?: string;
  public updateDate: Date;
  public daysOverdue?: number;
  public daysUntilDue?: number;
  public daysOpen?: number;

  constructor({
    accessLevel = undefined,
    assignedTo = undefined,
    comments = undefined,
    completedBy = undefined,
    completedDate = undefined,
    createdBy = undefined,
    creationDate = undefined,
    dueDate = undefined,
    hours = undefined,
    id = undefined,
    isComplete = undefined,
    isLastTask = undefined,
    isOverDue = undefined,
    isVisibleToSubject = undefined,
    notes = undefined,
    originTaskId = undefined,
    relatedEntity = undefined,
    status = undefined,
    subject = undefined,
    summary = undefined,
    taskTemplateName = undefined,
    taskType = undefined,
    taskTypeLabel = undefined,
    updateDate = undefined,
    daysOverdue = undefined,
    daysUntilDue = undefined,
    daysOpen = undefined,
    }: TaskInterface) {
    this.accessLevel = accessLevel;
    this.assignedTo = assignedTo ? new User(assignedTo) : undefined;
    this.comments = comments;
    this.completedBy = completedBy ? new User(completedBy) : undefined;
    this.completedDate = completedDate;
    this.createdBy = createdBy ? new User(createdBy) : undefined;
    this.creationDate = creationDate;
    this.dueDate = dueDate;
    this.hours = hours;
    this.id = id;
    this.isComplete = isComplete;
    this.isLastTask = isLastTask;
    this.isOverDue = isOverDue;
    this.isVisibleToSubject = isVisibleToSubject;
    this.notes = notes;
    this.originTaskId = originTaskId;
    this.relatedEntity = relatedEntity;
    this.status = status;
    this.subject = subject ? new User(subject) : undefined;
    this.summary = summary;
    this.taskTemplateName = taskTemplateName;
    this.taskType = taskType;
    this.taskTypeLabel = taskTypeLabel;
    this.updateDate = updateDate;
    this.daysOverdue = daysOverdue;
    this.daysUntilDue = daysUntilDue;
    this.daysOpen = daysOpen;
  }
}
